var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "SNMedicalWidget" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c(
            "panel-basic",
            {
              staticClass: "rounded-top",
              staticStyle: { "border-radius": "25px" },
              attrs: {
                title: _vm.field.FIELD_LABEL,
                helpText: _vm.field.DISTRICT_HELP_TEXT,
                collapsable: true,
                id: "panel",
                "panel-class": "full-height"
              }
            },
            [
              _vm.field.FIELD_FILE_URL
                ? [
                    _c("div", { staticStyle: { "margin-top": "-15px" } }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.displayText.attachmentWithColon) +
                          "  "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.field.FIELD_FILE_URL,
                            target: "_blank"
                          }
                        },
                        [_vm._v(_vm._s(_vm.field.FIELD_DOC_FILENAME))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("br")
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.isValidDateForm
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-md-12" },
                      [
                        (_vm.formAction !== "normal" &&
                          !!_vm.existingAbsenceDate) ||
                        (!!_vm.formData.CHECKED_DATES &&
                          _vm.formData.CHECKED_DATES.length > 0)
                          ? [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.displayText.selectDates) + " "
                                ),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass: "list-group",
                                  staticStyle: {
                                    "max-height": "400px",
                                    "overflow-y": "auto",
                                    border: "1px solid #ccc"
                                  }
                                },
                                _vm._l(
                                  _vm.formData.STUDENT_UNEXCUSED_DAYS,
                                  function(attend, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: attend.DATE,
                                        staticClass: "list-group-item"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.formData.CHECKED_DATES,
                                              expression:
                                                "formData.CHECKED_DATES"
                                            }
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            name: "existingDays",
                                            id: "date_" + index,
                                            disabled:
                                              _vm.isReadOnly ||
                                              _vm.isLastOneChecked(attend.DATE)
                                          },
                                          domProps: {
                                            value: attend.DATE,
                                            checked: Array.isArray(
                                              _vm.formData.CHECKED_DATES
                                            )
                                              ? _vm._i(
                                                  _vm.formData.CHECKED_DATES,
                                                  attend.DATE
                                                ) > -1
                                              : _vm.formData.CHECKED_DATES
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a =
                                                  _vm.formData.CHECKED_DATES,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = attend.DATE,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "CHECKED_DATES",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "CHECKED_DATES",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "CHECKED_DATES",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              "font-weight": "normal"
                                            },
                                            attrs: { for: "date_" + index }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(attend.DATE) +
                                                " " +
                                                _vm._s(attend.ATTENDANCE_CODE) +
                                                " - " +
                                                _vm._s(
                                                  attend.ATTENDANCE_CODE_DESC
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ]
                          : _vm.allowRange
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-6 col-xs-12",
                                  staticStyle: { "margin-left": "-15px" }
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.displayText.absenceDateFrom)
                                    ),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    ref: "provider",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("date-picker", {
                                                staticStyle: {
                                                  display: "contents"
                                                },
                                                attrs: {
                                                  id: "attendanceWidgetDate",
                                                  name: "attendanceWidgetDate",
                                                  lang: "en",
                                                  format: "MM/DD/YYYY",
                                                  clearable: false,
                                                  "disabled-days":
                                                    _vm.disabledDate,
                                                  disabled: _vm.isReadOnly,
                                                  "not-before":
                                                    _vm.disabledBefore,
                                                  "not-after":
                                                    _vm.disabledAfter,
                                                  "fixed-position":
                                                    "bottom-right"
                                                },
                                                model: {
                                                  value: _vm.formData.DATE_FROM,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "DATE_FROM",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.DATE_FROM"
                                                }
                                              }),
                                              _vm._v(" "),
                                              errors.length
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            errors[0].replace(
                                                              "{field}",
                                                              "Absence Date"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      572094135
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 col-xs-12" },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", {
                                      staticClass: "col-xs-12 col-md-6"
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.displayText.absenceDateTo)
                                    ),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("*")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    ref: "provider",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("date-picker", {
                                                ref: "dateToPicker",
                                                staticStyle: {
                                                  display: "contents"
                                                },
                                                attrs: {
                                                  id: "attendanceWidgetDate2",
                                                  name: "attendanceWidgetDate2",
                                                  lang: "en",
                                                  format: "MM/DD/YYYY",
                                                  clearable: false,
                                                  "disabled-days":
                                                    _vm.disabledDate2,
                                                  disabled: _vm.isReadOnly,
                                                  "not-before":
                                                    _vm.disabledBefore,
                                                  "not-after":
                                                    _vm.disabledAfter,
                                                  "fixed-position":
                                                    "bottom-right"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.setCorrectDate()
                                                  }
                                                },
                                                model: {
                                                  value: _vm.formData.DATE_TO,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "DATE_TO",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.DATE_TO"
                                                }
                                              }),
                                              _vm._v(" "),
                                              errors.length
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            errors[0].replace(
                                                              "{field}",
                                                              "Absence Date"
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3308676121
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("br")
                            ]
                          : [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.displayText.absenceDate) + " "
                                ),
                                _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v("*")
                                ])
                              ]),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                ref: "provider",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("date-picker", {
                                            staticStyle: {
                                              display: "contents"
                                            },
                                            attrs: {
                                              id: "attendanceWidgetDate",
                                              name: "attendanceWidgetDate",
                                              lang: "en",
                                              format: "MM/DD/YYYY",
                                              clearable: false,
                                              "disabled-days": _vm.disabledDate,
                                              disabled: _vm.isReadOnly,
                                              "not-before": _vm.disabledBefore,
                                              "not-after": _vm.disabledAfter
                                            },
                                            model: {
                                              value: _vm.formData.DATE,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "DATE",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.DATE"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1190693272
                                )
                              })
                            ],
                        _vm._v(" "),
                        ((!_vm.formData.CHECKED_DATES ||
                          _vm.formData.CHECKED_DATES.length === 0) &&
                          !_vm.field.WIDGET_OPTIONS
                            .WID_ALLOW_HISTORIC_DATES_FLG) ||
                        _vm.field.WIDGET_OPTIONS
                          .WID_ALLOW_HISTORIC_DATES_FLG !== "Y"
                          ? _c("p", { staticClass: "info" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.displayText.attendanceDateMessage
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-xs-12" },
                            [
                              _c("ValidationProvider", {
                                ref: "provider",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.displayText.absenceReason
                                              ) + " "
                                            ),
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.formData
                                                    .ATTENDANCE_REASON,
                                                expression:
                                                  "formData.ATTENDANCE_REASON"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              name: "attendanceWidgetReason",
                                              id: "attendanceWidgetReason",
                                              disabled: _vm.isReadOnly
                                            },
                                            domProps: {
                                              value:
                                                _vm.formData.ATTENDANCE_REASON
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.formData,
                                                  "ATTENDANCE_REASON",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          errors.length
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        errors[0].replace(
                                                          "{field}",
                                                          "Reason for Absence"
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("br")
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3815791857
                                )
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.displayText.attachDocuments)
                          ),
                          !!_vm.field.WIDGET_OPTIONS
                            .WID_REQUIRE_FILEUPLOAD_FLG &&
                          _vm.field.WIDGET_OPTIONS
                            .WID_REQUIRE_FILEUPLOAD_FLG === "Y"
                            ? _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*")
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.loadedFilePickerData && !_vm.isReadOnly
                          ? _c(
                              "div",
                              {
                                staticClass: "dropzone-area",
                                on: { mousedown: _vm.doFetchToken }
                              },
                              [
                                _c("file-uploader", {
                                  ref: "fileUpload",
                                  attrs: {
                                    inputId: "fileUpload_" + _vm.field.FIELD_ID,
                                    size: 52428800,
                                    multiple: true,
                                    files: _vm.tempFiles,
                                    URL: _vm.externalFileData,
                                    postAction:
                                      "/PortalAPI/index.cfm/api/v1/data-verification-forms/field-files?dv_form_id=" +
                                      _vm.field.DV_FORM_ID +
                                      "&field_id=" +
                                      _vm.field.FIELD_ID +
                                      "&instance_id=" +
                                      _vm.instanceID +
                                      "&student_rid=" +
                                      _vm.selectedStudent.STUDENT_RID,
                                    auth: {
                                      Authorization: _vm.accessToken,
                                      "Client-ID": _vm.clientID
                                    }
                                  },
                                  on: {
                                    updateFiles: function($event) {
                                      return _vm.updateFiles(
                                        $event,
                                        _vm.field.FIELD_ID
                                      )
                                    },
                                    saveGoogleFilesData: function($event) {
                                      return _vm.saveGoogleFilesData(
                                        (_vm.file = $event),
                                        (_vm.multiple = true),
                                        _vm.field.FIELD_ID
                                      )
                                    },
                                    saveDropboxFilesData: function($event) {
                                      return _vm.saveDropboxFilesData(
                                        (_vm.file = $event),
                                        (_vm.multiple = true),
                                        _vm.field.FIELD_ID
                                      )
                                    },
                                    saveOneDriveFilesData: function($event) {
                                      return _vm.saveOneDriveFilesData(
                                        (_vm.file = $event),
                                        (_vm.multiple = true),
                                        _vm.field.FIELD_ID
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.displayText.uploadFilesTitleCase
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list-group" },
                          _vm._l(_vm.formValues.DATA.FILES, function(
                            file,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: file.HASHA + file.FILE_IDX,
                                staticClass: "list-group-item"
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-xs-11" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: file.FILE_URL,
                                          target: "_blank"
                                        }
                                      },
                                      [_vm._v(_vm._s(file.DV_FILE_NAME))]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-1 text-right" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.deleteFile(
                                                file.DV_FORM_ID,
                                                file.FIELD_ID,
                                                file.FILE_IDX,
                                                file.INSTANCE_ID,
                                                file.STUDENT_RID,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "label label-danger"
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: "times" }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.debug
                          ? _c(
                              "pre",
                              {
                                staticStyle: {
                                  height: "200px",
                                  overflow: "scroll"
                                }
                              },
                              [
                                _vm._v(
                                  "\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      JSON.stringify(_vm.formValues, null, 2)
                                    ) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  : _c("div", { staticClass: "alert alert-danger" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(_vm.displayText.attendanceNoDatesMessage) +
                          "\n\t\t\t\t\t\t"
                      )
                    ])
              ])
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }